import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-votos-distrito',
  templateUrl: './votos-distrito.component.html',
  styleUrls: ['./votos-distrito.component.scss']
})
export class VotosDistritoComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
